import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Overview from "../../Overview";
import engageAIContent from "./EngageAIContent";
import Usecase from "../../UseCase";
import CustomerStory from "../../CustomerStory";
import Resources from "../../Resources";
import Demo from "../../Demo";
import EngageAIPricing from "../../Pricing";

function EngageAI({ selectedSection = "Overview" }) {
  const renderActiveSection = () => {
    switch (selectedSection) {
      case "Demos":
        return (
          <motion.div
            key="demos"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <Demo content={engageAIContent.demos} productTitle="EngageAI" />
          </motion.div>
        );
      case "Pricing":
        return (
          <motion.div
            key="pricing"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <EngageAIPricing content={engageAIContent} />
          </motion.div>
        );
      case "Use Cases":
        return (
          <motion.div
            key="use-cases"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <Usecase content={engageAIContent.usecase} />
          </motion.div>
        );
      case "Customer Stories":
        return (
          <motion.div
            key="customer-stories"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <CustomerStory content={engageAIContent.customerstory} />
          </motion.div>
        );
      case "Resources":
        return (
          <motion.div
            key="resources"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          >
            <Resources content={engageAIContent.resources} />
          </motion.div>
        );
      case "Overview":
      default:
        return (
          <motion.div
            key="overview-all"
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            style={{ display: "flex", flexDirection: "column", gap: "60px" }}
          >
            <div id="section-overview" className="partner-overview-section">
              <Overview content={engageAIContent.overview} />
            </div>
            <div id="section-demos" className="partner-overview-section">
              <Demo content={engageAIContent.demos} />
            </div>
            <div id="section-pricing" className="partner-overview-section">
              <EngageAIPricing content={engageAIContent} />
            </div>
            <div id="section-usecases" className="partner-overview-section">
              <Usecase content={engageAIContent.usecase} />
            </div>
            <div id="section-customer-stories" className="partner-overview-section">
              <CustomerStory content={engageAIContent.customerstory} />
            </div>
            <div id="section-resources" className="partner-overview-section">
              <Resources content={engageAIContent.resources} />
            </div>
          </motion.div>
        );
    }
  };

  return (
    <div className="partner-apple-stage-container">
      <AnimatePresence mode="wait">{renderActiveSection()}</AnimatePresence>
    </div>
  );
}

export default EngageAI;
